// export { default as FormRender } from './FormRender/FormRender';
import FormRender from './FormRender/FormRender';
export default {
  FormRender,
};
